import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [config, setConfig] = useState(null);
  const refresh = useCallback(async () => {
    if (!localStorage.getItem("tt_token")) { setUser(false); return false; }
    try { const { data } = await api.get("/auth/me"); setUser(data); return data; } catch { setUser(false); return false; }
  }, []);
  useEffect(() => {
    refresh();
    api.get("/config").then((r) => setConfig(r.data)).catch(() => setConfig({}));
  }, [refresh]);
  const login = (token, u) => { localStorage.setItem("tt_token", token); setUser(u); refresh(); };
  const logout = async () => { localStorage.removeItem("tt_token"); setUser(false); try { await api.post("/auth/logout"); } catch { /* ignore */ } };
  return <Ctx.Provider value={{ user, config, refresh, login, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
